import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from '../Title';
// Icons
import ClearAllIcon from '@mui/icons-material/ClearAll';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EngineeringIcon from '@mui/icons-material/Engineering';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import RestoreIcon from '@mui/icons-material/Restore';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import InsightsIcon from '@mui/icons-material/Insights';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import NightsStayIcon from '@mui/icons-material/NightsStay';

// Styles
import { blue_pilu } from '../../../../helpers/utils';
import { APPOINTMENTS_NAMES } from '../../../utils/lists';
import { IndicatorDialog } from '../IndicatorDialog';

const useStyles = makeStyles({
	depositContext: {
		flex: 1,
	},
});

const measures = '35%';

export const iconStyle = {
	color: blue_pilu,
	width: measures,
	height: measures,
};

const ICONS = {
	toComplete: <ClearAllIcon style={iconStyle} />,
	inProgress: <EngineeringIcon style={iconStyle} />,
	completed: <TaskAltIcon style={iconStyle} />,
	cancelled: <DoNotDisturbIcon style={iconStyle} />,
	postponed: <EventRepeatIcon style={iconStyle} />,
	totalEvents: <FormatListBulletedIcon style={iconStyle} />,
	fullToComplete: <RestoreIcon style={iconStyle} />,
	dayRate: <InsightsIcon style={iconStyle} />,
};

const ICONS_CUSTOM_COLOR = {
	morning: <WbTwilightIcon style={{ ...iconStyle, color: '#FFC107' }} />,
	afternoon: <WbSunnyIcon style={{ ...iconStyle, color: '#FF5722' }} />,
	evening: <NightsStayIcon style={iconStyle} />,
};

const LABELS = {
	totalEvents: 'Todas las citas del día',
	fullToComplete: 'Pendientes + En progreso',
	dayRate: 'Porcentaje del avance del día',
};

export const Indicator = ({
	name = '',
	value = [],
	icon = null,
	subtitle = null,
	noCursor = false,
}) => {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div>
			{typeof value === 'object' && (
				<IndicatorDialog
					open={open}
					handleClose={handleClose}
					data={value}
					name={`${icon ? name : APPOINTMENTS_NAMES[name]} (${
						value.length
					})`}
				/>
			)}

			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'space-between',
					cursor:
						noCursor || typeof value !== 'object'
							? 'auto'
							: 'pointer',
				}}
				onClick={() => {
					if (name !== 'inProgress') handleOpen();
				}}
			>
				<div>
					<Title>{icon ? name : APPOINTMENTS_NAMES[name]}</Title>
					<Typography component='p' variant='h4'>
						{typeof value === 'object' ? value.length : value}
						{name === 'dayRate' && '%'}
					</Typography>
				</div>
				{icon ? ICONS_CUSTOM_COLOR[icon] : ICONS[name]}
			</div>

			<Typography
				style={{ margin: '10px 0' }}
				color='textSecondary'
				className={classes.depositContext}
			>
				<small>
					{Object.keys(LABELS).includes(name)
						? LABELS[name]
						: subtitle
						? subtitle
						: 'Haz clic para ver el detalle'}
				</small>
			</Typography>
		</div>
	);
};
